import React from 'react';
import ReactDOMClient from 'react-dom/client';

import App from './app';

ReactDOMClient.createRoot(
  // eslint-disable-next-line unicorn/prefer-query-selector
  document.getElementById('root') as HTMLElement
).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
